<template>
  <div class="text-wrapper">
    <p class="district">{{ displayName }}</p>
    <p
      class="cases"
      :style="textStyle"
    >
      <span class="count">
        {{ total }}
      </span>
      {{ $tc('case', total) }}
    </p>
    <p class="ago">
      {{$t("last_appearance", {days: lastOccurance, dayword: $tc("day", lastOccurance)})}}
    </p>
    <div
      class="details"
      ref="details"
    >
      {{$t('cases_involved')}}: <br />
      <span
        v-for="(caseid, index) in ary"
        :key="caseid"
        class="case-id"
      >
        #{{ caseid }}
        <template v-if="index !== ary.length - 1">, </template>

      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import i18n from "../i18n";
export default Vue.extend({
  i18n: i18n,
  props: {
    district: {
      required: true,
      type: Boolean
    },
    name: {
      required: true,
      type: String
    },
    name_zh: {
      required: true,
      type: String
    },
    color: {
      required: true,
      type: String
    },
    total: {
      required: true,
      type: Number
    },
    cases: {
      required: true,
      type: String
    },
    lastday: {
      required: true,
      type: String
    }
  },
  computed: {
    ary() {
      const ary = this.cases
        .replace("[", "")
        .replace("]", "")
        .replace(/ /g, "")
        .replace(/"/g, "")
        .split(",");
      return ary.map(x => parseInt(x));
    },
    lastOccurance() {
      const dateAry = this.lastday.split("/");
      const lastCaseDate = new Date(dateAry[2], dateAry[1] - 1, dateAry[0]);
      const currentDate = new Date();
      return Math.floor(
        (Date.UTC(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        ) -
          Date.UTC(
            lastCaseDate.getFullYear(),
            lastCaseDate.getMonth(),
            lastCaseDate.getDate()
          )) /
          (1000 * 60 * 60 * 24)
      );
    },
    textStyle() {
      return "color: " + this.color;
    },
    displayName() {
      if (this.district) {
        return this.$t("districts." + this.name);
      } else {
        if (this.$i18n.locale == "en") {
          return this.name;
        } else {
          return this.name_zh;
        }
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.text-wrapper {
  display: inline-block;
  padding: 10px;
  font-size: 14px;
  font-size: 14px;

  p {
    margin: 0;
    line-height: 1.4;
  }

  p.district {
    font-weight: 700;
    font-family: $type-normal;
    color: $hku-black;
  }
  p.cases {
    font-weight: 600;
    font-family: $type-number;

    span.count {
      font-size: 1.8em;
      letter-spacing: -0.05em;
    }
  }
  p.ago {
    color: $hku-gray-2;
    line-height: 1.2;
  }

  .details {
    margin: 15px auto 0 auto;
    border-radius: 3px;
    background: $hku-offwhite;
    padding: 8px 10px;
    width: 100%;
    text-align: left;
    max-height: 80px;
    overflow-y: scroll;
    font-family: $type-normal;
    color: $hku-gray-2;

    .case-id a {
      font-family: $type-number;
      color: $hku-gray-1;
      font-weight: 600;
      text-decoration: underline;
      transition: 0.1s linear;
      &:active,
      &:hover {
        color: $hku-black;
      }
    }
  }
}
</style>
